// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".movies-browser__header {\n  height: calc(1.25rem * 1.25 + 1rem * 2);\n}\n", ""]);
// Exports
module.exports = exports;
